module.exports = __webpack_public_path__ + "static/media/bl.8458b578.svg";